module.exports = __webpack_public_path__ + "static/berkshirehathaway-ef8bd6fff643283246b99f027d803cce.webp";